/** Recognize legacy Search return links so they can safely redirect to Users. */
export function normalizeCrmCombinedSearchReturnTo(value: string | undefined): string | undefined {
  if (
    value === undefined ||
    value.length > 4096 ||
    !value.startsWith('/') ||
    value.startsWith('//')
  ) {
    return undefined;
  }
  const url = new URL(value, 'https://move.local');
  if (url.origin !== 'https://move.local' || !/^\/(en|ru)\/crm\/search$/u.test(url.pathname)) {
    return undefined;
  }
  return `${url.pathname}${url.search}${url.hash}`;
}
